import React from 'react'
import PropTypes from 'prop-types'
import NotificationPanelContainer from '../NotificationPanel/NotificationPanelContainer'

import ErrorBoundary from '../ErrorBoundary/ErrorBoundary'

import { DEFAULT_AUTH_SCHEME, DEFAULT_AUTH_HEADER } from '../../lib/api'

import { SERVICE_WORKER_FILENAME } from '../../lib/firebasePushNotification'

// eslint-disable-next-line react/prefer-stateless-function
class Root extends React.Component {
  render() {
    const {
      env,
      authToken,
      apiHost,
      authScheme,
      authHeader,
      firebaseConfig,
      sentryDSN,
      bellButtonIcon,
      serviceWorkerFilename,
      registerServiceWorker,
      getDataOnMount,
      productIdentifier
    } = this.props

    return (
      <ErrorBoundary env={env} sentryDSN={sentryDSN}>
        <NotificationPanelContainer
          sentryDSN={sentryDSN}
          firebaseConfig={firebaseConfig}
          bellButtonIcon={bellButtonIcon}
          authScheme={authScheme}
          authToken={authToken}
          authHeader={authHeader}
          env={env}
          apiHost={apiHost}
          serviceWorkerFilename={serviceWorkerFilename}
          registerServiceWorker={registerServiceWorker}
          getDataOnMount={getDataOnMount}
          productIdentifier={productIdentifier}
        />
      </ErrorBoundary>
    )
  }
}

Root.defaultProps = {
  env: null,
  authScheme: DEFAULT_AUTH_SCHEME,
  authHeader: DEFAULT_AUTH_HEADER,
  serviceWorkerFilename: SERVICE_WORKER_FILENAME,
  registerServiceWorker: true,
  getDataOnMount: true,
  authToken: null,
  firebaseConfig: {},
  bellButtonIcon: null,
  productIdentifier: null
}

Root.propTypes = {
  productIdentifier: PropTypes.string,
  env: PropTypes.string,
  sentryDSN: PropTypes.string,
  apiHost: PropTypes.string.isRequired,
  authToken: PropTypes.string,
  authHeader: PropTypes.string,
  authScheme: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  bellButtonIcon: PropTypes.string,
  serviceWorkerFilename: PropTypes.string,
  firebaseConfig: PropTypes.shape({}),
  registerServiceWorker: PropTypes.bool,
  getDataOnMount: PropTypes.bool
}

export default Root
